import { useMemo } from 'react';
import { Box, ButtonBase, Dialog, makeStyles } from '@material-ui/core';
import { CloseIcon } from '../../../../../components/Icon';
import StyleButton from '../../../../../components/StyleButton';
import { i18n } from '../../../../../language';
import { UPDATE_STATUS } from './EditRobot';

const useStyles = makeStyles(() => ({
  root: {
    '& .MuiDialog-paperWidthSm': {
      maxWidth: 'none',
    },
    '& .MuiPaper-root': {
      backgroundColor: '#FFFFFF',
      borderRadius: '15px !important',
      boxShadow: '0 -0.125rem 1.3125rem rgba(30, 56, 140, 0.18)',
      margin: '0',
      paddingTop: '2.722rem',
      width: '44.375rem',
    },
  },
  title: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.5rem',
    color: '#2e4469',
  },
  subTitle: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '0.875rem',
    color: '#7d86a9',
  },
  closeBtn: {
    width: '1.945rem',
    height: '1.945rem',
  },
  closeIcon: {
    fontSize: '1.5rem',
    color: '#538fff',
  },
  contentText: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
    color: '#2e4469',
  },
}));
const UpdateRobot = ({ onClose, updateApi, updateStatus }) => {
  const classes = useStyles();
  const comfirmBtn = () => {
    if (typeof updateApi === 'function') {
      updateApi();
    }
  };

  const copywriting = useMemo(() => {
    switch (updateStatus) {
      case UPDATE_STATUS.UPDATE:
        return {
          title: 'TELEVISIT_SETTING_POPUP_UPDATE_ROBOT_TITLE',
          content: 'TELEVISIT_SETTING_POPUP_UPDATE_ROBOT_CONTENT',
          cancel: 'SETTING_CANCEL',
          confirm: 'SETTING_CONFIRM',
        };
      case UPDATE_STATUS.AVAILABLE_TO_UNAVAILABLE:
        return {
          title: 'TELEVISIT_SETTING_POPUP_UPDATE_ROBOT_TO_UNAVAILABLE_TITLE',
          content: 'TELEVISIT_SETTING_POPUP_UPDATE_ROBOT_TO_UNAVAILABLE_CONTENT',
          cancel: 'SETTING_CANCEL',
          confirm: 'SETTING_CONFIRM',
        };
      case UPDATE_STATUS.UNAVAILABLE_TO_AVAILABLE:
        return {
          title: 'TELEVISIT_SETTING_POPUP_UPDATE_ROBOT_TO_AVAILABLE_TITLE',
          content: 'TELEVISIT_SETTING_POPUP_UPDATE_ROBOT_TO_AVAILABLE_CONTENT',
          cancel: 'SETTING_CANCEL',
          confirm: 'SETTING_CONFIRM',
        };

      default:
        break;
    }
  }, [updateStatus]);

  return (
    <Box>
      <Dialog className={classes.root} open={true}>
        <Box display="flex" justifyContent="space-between" mb="1.965rem" p="0 1.875rem">
          <div className={classes.title}>{i18n.t(copywriting.title)}</div>
          <ButtonBase className={classes.closeBtn} onClick={onClose}>
            <CloseIcon className={classes.closeIcon} />
          </ButtonBase>
        </Box>
        <Box p="0 1.938rem">
          <div className={classes.contentText} dangerouslySetInnerHTML={{ __html: i18n.t(copywriting.content) }} />
        </Box>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          p="1.125rem"
          mt="1.5rem"
          borderTop="solid 1px #e4e7eb"
          gridColumnGap="1.25rem"
        >
          <StyleButton
            text={i18n.t(copywriting.cancel)}
            width="17.875rem"
            height="2.875rem"
            type="fill"
            backgroundColor="#f5faff"
            color="#538fff"
            onClick={onClose}
          />
          <StyleButton
            text={i18n.t(copywriting.confirm)}
            width="17.875rem"
            height="2.875rem"
            type="fill"
            onClick={comfirmBtn}
          />
        </Box>
      </Dialog>
    </Box>
  );
};
export default UpdateRobot;
